<template>
<div class="page-container">
    <div class="datalist-parent"><DataList 
        title="SSBO Project Staffing" 
        :test="false" 
        :expandable="false"
        :graphable="true"
        :data="data" 
        :columnTitles="['NAME','TITLE','CLIENT','PROJECT', 'LATEST MONTH (May-22)', '% OF TOTAL PROJECT HOURS']"
        :columnKeys="['name','title','client','project', 'latestMonth', 'percentHours']"
        @addToList="handleAdd()"
        @exportList="handleExport()"
    /></div>
</div>
</template>

<script>
import DataList from '@/components/DataList';
import firebase from 'firebase';

export default {
    name: 'project_staffings',
    components: {
        DataList
    },
    data() {
        return {
            data: []
        }
    },
    mounted() {
        console.log('project stagging mounted');
        this.fetchProjectStaffings();
    },
    methods: {
        async fetchProjectStaffings() {
            await firebase.firestore().collection('project_staffings').get().then((docs) => {
                docs.forEach((doc) => {
                    var postData = {...doc.data(), truePercent: parseInt(doc.data().percentHours.substring(0,doc.data().percentHours.length-1))}
                    this.data.push(postData);
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    background: #eee;
}

.datalist-parent {
    width: 85%;
    margin: 0px;
    padding: 0px;
}
</style>